<template>
	<div class="full-width">
		<AppTable main-color="#6c33cb" ref="logs-table"
				  :fetch-function="getFilteredLogs"
				  :filters="filters"
				  :table-headings="tableHeadings"
				  :title="getString('logs')"
				  :total-items="superLogsTotal || 0"
				  :items="superLogs || []"
				  initial-sort-field="date"
				  @failed-fetch="details=>{$emit('failed-fetch', details)}" >
		</AppTable>

		<AppNotification :title="getString('error')" :body-text="getString('generic_error')" :type="-2" ref="generic-error" />
	</div>
</template>

<script>
import API from "@/shared/helpers/API";
import AppButtonIcon from "@/shared/components/AppButtonIcon.vue";
import AppTable from "@/shared/components/AppTable.vue";
import {useLanguageStore} from "@/shared/stores";
import {getLocalDateFromServer} from "@/shared/helpers/dates";
import AppNotification from "@/shared/components/AppNotification.vue";

export default {
	setup() {
		const languageStore = useLanguageStore();
		return {getString: languageStore.getString}
	},
	name: "SuperLogs",
	components: {AppNotification, AppButtonIcon, AppTable},
	data() {
		return {
			superLogsTotal: 0,
			superLogs: [],
			filters: [
				{
					type: "date",
					key: 'date',
					tableName: 'users_logs',
					text: this.getString('date'),
					finalValue: '',
					active: false
				},
			],
			tableHeadings: [
				{
					text: this.getString('date'),
					cols: 1,
					sortable: true,
					fieldName: 'date',
				},
				{
					text: this.getString('user_email'),
					cols: 1,
					fieldName: 'email',
				},
				{
					text: this.getString('type'),
					cols: 1,
					fieldName: 'type',
				},
				{
					text: this.getString('description'),
					cols: 3,
					fieldName: 'log',
				},
			],
		}
	},
	methods: {
		getFilteredLogs(filters, callback = null) {

			API.init().getSuperLogs(JSON.stringify(filters || []), r=> {
				this.superLogs = [];
				this.superLogsTotal = 0;
				if(r && r.result === "OK") {
					if(r.logs && r.logs.selected && r.logs.selected.length) {
						r.logs.selected.forEach(t => {
							this.superLogs.push(this.normalizeLog(t));
						});
						this.superLogsTotal = Number(r.logs.selected_num || 0);
					}
					if(callback) { callback(true); }
				} else {
					this.$refs["generic-error"].openNotification();
					if(callback) { callback(false, r ? r.details : null); }
				}
			});

		},
		normalizeLog(log) {
			log.date = log.date ? getLocalDateFromServer(log.date) : null;
			log.log = "unknown";
			let data = log.data ? JSON.parse(log.data) : null;
			if(data) {
				if(log.type === "super_force_login") {
					log.log = (data.granted ? "granted - " : "NOT granted - ")+(data.user_id ? "user #"+data.user_id : "")+(data.business_id ? " - business #"+data.business_id : "");
				} else if(log.type === "super_update_payout_delay") {
					log.log = "business #"+data.business_id+" - new payout delay: "+data.delay;
				} else if(log.type === "super_update_payout_interval") {
					log.log = "business #"+data.business_id+" - new payout interval: "+data.interval;
				} else if(log.type === "super_update_commissions") {
					log.log = "business #"+data.business_id+" - new commissions "+(data.is_pos ? "POS" : "Order&Pay")+" -> "+(Number(data.fixed)/100).toFixed(2)+"€ + "+((Number(data.percentPremium)) ? "( " : "" )+(Number(data.percent)).toFixed(2)+"%"+((Number(data.percentPremium)) ? " + "+(Number(data.percentPremium)).toFixed(2)+"% )" : "" );
				} else if(log.type === "super_update_rule") {
					log.log = "business #"+data.business_id+" - new commissions "+(data.fee_type === "pos" ? "POS" : "Order&Pay")+" -> "+(Number(data.fixed)/100).toFixed(2)+"€ | "+((Number(data.premium_percent)) ? "( " : "" )+(Number(data.percent)).toFixed(2)+"%"+((Number(data.premium_percent)) ? " + "+(Number(data.premium_percent)).toFixed(2)+"% )" : "" ) + (data.fee_type !== "pos" ? " | ( "+(Number(data.alternative_fixed)/100).toFixed(2)+"€ + "+(Number(data.alternative_percent))+"% )" : "");
				} else if(log.type.startsWith("super_update_type_")) {
					log.log = "business #"+data.business_id;
				} else if(log.type === "super_update_credits") {
					log.log = "business #"+data.business_id+" - new balance "+(Number(data.credits)/100).toFixed(2)+"€";
				} else if(log.type === "super_migrate_stripe") {
					log.log = "business #"+data.business_id;
				} else if(log.type === "super_emit_invoice_again") {
					log.log = "business #"+data.business_id+" - invoice #"+data.business_invoice_id+" status "+data.state;
				} else if(log.type === "super_emit_invoice_manual") {
					log.log = "business #"+data.business_id+" - invoice #"+data.business_invoice_id;
				} else if(log.type === "super_emit_new_invoice") {
					log.log = "business #"+data.business_id+" - invoice #"+data.business_invoice_id+" - amount "+(Number(data.total)/100).toFixed(2)+"€ - object "+data.object;
				} else if(log.type === "super_emit_new_quote") {
					log.log = "business #"+data.business_id+" - amount "+(Number(data.total)/100).toFixed(2)+"€ - object "+data.object;
				} else if(log.type === "super_update_allow_tap_to_pay") {
					log.log = "business #"+data.business_id+" - value "+(data.allow_tap_to_pay ? "true" : "false");
				} else if(log.type === "super_mark_quote_paid_manual") {
					log.log = "quote #"+data.quote_id+" marked as paid ";
				} else if(log.type === "super_update_server_resources") {
					log.log = "Server resources updated - Servers: "+data.server_numbers+" - DB Size (ACU): "+data.db_size+" - Duration: "+data.hours_of_traffic+" hours";
				}
			}
			return log;
		},
	}
}
</script>

<style lang="scss" scoped>
.no-download {
	font-size: 12px;
}
.full-width {
	width: 100%;
}
</style>